module.exports = __webpack_public_path__ + "static/media/trophy-line.c031153d.svg";